module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Foreword#fm-1"
    }
  }, [_c('em', [_vm._v("Foreword")]), _vm._v(" by Emerson B. Powery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Preface#fm-2"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#fm-3"
    }
  }, [_c('strong', [_vm._v("Introduction: African American Pauline Hermeneutics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-1"
    }
  }, [_vm._v("What Is African American Pauline Hermeneutics?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-2"
    }
  }, [_vm._v("The Significance of Pauline African American Interpreters in Reception History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-1"
    }
  }, [_c('em', [_vm._v("Previous Scholarship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-2"
    }
  }, [_c('em', [_vm._v("Methodology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_c('strong', [_vm._v("1. Early Eighteenth Century to Early Nineteenth Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-3"
    }
  }, [_vm._v("Early Petitions for Freedom and Liberty That Cite Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-4"
    }
  }, [_vm._v("Jupiter Hammon (1711–[1790–1806?]): The First Published African American Poet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-3"
    }
  }, [_c('em', [_vm._v("“A Winter Piece”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-4"
    }
  }, [_c('em', [_vm._v("“An Evening’s Improvement”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-5"
    }
  }, [_c('em', [_vm._v("“An Address to the Negroes in the State of New York”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-5"
    }
  }, [_vm._v("Lemuel Haynes (1753–1833): The First Ordained Black American")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-6"
    }
  }, [_c('em', [_vm._v("Lemuel Haynes’s Use of Paul to Critique the Ham Myth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-7"
    }
  }, [_c('em', [_vm._v("Haynes’s Reading of 1 Corinthians 7:21")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-8"
    }
  }, [_c('em', [_vm._v("Haynes Challenges the Idea of the Divine Providence of Slavery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-6"
    }
  }, [_vm._v("John Jea (1773–1817[?]): The African Preacher and Miracle of Literacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-7"
    }
  }, [_vm._v("Jarena Lee (1783–1850[?]): One of the First Black Women Preachers in the African Methodist Episcopal Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-9"
    }
  }, [_c('em', [_vm._v("Jarena Lee’s Conversion and Sanctification in Pauline Language")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-10"
    }
  }, [_c('em', [_vm._v("Lee’s Call to Preach in Pauline Terms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-11"
    }
  }, [_c('em', [_vm._v("Lee as Paul: The Colored Woman Preacher Sent to Jerusalem and “Operations of the Spirit”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-8"
    }
  }, [_vm._v("Zilpha Elaw (1790[?]–?): Renowned Early Black Woman Preacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-12"
    }
  }, [_c('em', [_vm._v("The Pauline Contours of Zilpha Elaw’s Autobiography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-13"
    }
  }, [_c('em', [_vm._v("Elaw’s Conversion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-14"
    }
  }, [_c('em', [_vm._v("Elaw’s Camp-Meeting Experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-15"
    }
  }, [_c('em', [_vm._v("Elaw’s Call to Preach and Opposition to Her Preaching")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-16"
    }
  }, [_c('em', [_vm._v("Miracles in Elaw’s Ministry and Her Interpretation of Paul’s Injunction on Women")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-17"
    }
  }, [_c('em', [_vm._v("Elaw and Spiritual Warfare")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-18"
    }
  }, [_c('em', [_vm._v("Elaw’s Travail for Transformation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-19"
    }
  }, [_c('em', [_vm._v("Elaw as Paul and Her Pauline Resistance to Racism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-9"
    }
  }, [_vm._v("David Walker (1785/1796–1830): Famous Abolitionist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-20"
    }
  }, [_c('em', [_vm._v("Horrors of Slavery and the God of This Age")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-21"
    }
  }, [_c('em', [_vm._v("The Religion of Jesus, Pretenders of Christianity, and Pauline Judgment Language")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-22"
    }
  }, [_c('em', [_vm._v("Judgment Revisited and Pauline “Body” Language: Salvation of the Black Body")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-23"
    }
  }, [_c('em', [_vm._v("Walker’s Farewell Discourse")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-10"
    }
  }, [_vm._v("Using Paul to Resist, Protest, and Be Subversive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2. Mid-Nineteenth Century to Late Nineteenth Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fugitive Slave Act and the Letter to Philemon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maria Stewart (1803–1879): First Female Public Lecturer on Political Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“Religion and the Pure Principles of Morality”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religion of Jesus in Pauline Terms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Stewart’s Focus on Black Unity and Black Agency")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Stewart’s Judgment Language")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Stewart’s Farewell Address")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“Power of Speaking” and “Why Cannot a Religious Spirit Animate Us Now?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Military Language Revisited: A Woman Warrior’s Labor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Pennington (1807–1870): The Fugitive Blacksmith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Great Moral Dilemma")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Gospel as Antisin and Antislavery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Letter to the Slaveholder")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel Payne (1811–1893): America’s First African American College President")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Words from the Spirit World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Election to Bishop and College President")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Welcome to the Ransomed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Julia Foote (1823–1900): Ordained Female Deacon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Foote’s Conversion, Sanctification, and Call to Preach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Excommunication and a Pauline Response")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-39",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Word to My Christian Sisters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harriet Jacobs (1813–1897): First Enslaved African American Woman to Write an Autobiography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-40",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Jacobs and the Cult of True Womanhood")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-41",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“One Great Wrong”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec2-42",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Jacobs’s Pauline Critique of Sexual Violence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using Paul to Challenge the Status Quo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3. Late Nineteenth Century to Mid-Twentieth Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reverdy Ransom (1861–1959): “Inspirer of Men and Movements”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-43",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“The Race Problem in a Christian State”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-44",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“The Negro, the Hope or the Despair of Christianity”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William J. Seymour (1870–1922): Bringer of Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-45",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("William Seymour’s Employment of Paul’s Spirit Language")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-46",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Paul’s Spirit Language and Racism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Harrison Mason (1864–1961): Founder of Largest Pentecostal Denomination in the United States")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-47",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Pauline Origin of a Denomination")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-48",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Baptism of the Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-49",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Paul and Racism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-50",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Paul and War")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ida B. Robinson (1891–1946): Denominational Founder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Howard Thurman (1899–1981): Twentieth-Century Pastor, Activist, Mystic, and Theologian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Albert Cleage Jr. (1911–2000): Advocate and Activist for the Black Nation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Martin Luther King Jr. (1929–1968): Theologian of Resistance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-51",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“Paul’s Letter to American Christians”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-52",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“Letter from Birmingham City Jail”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-53",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“Transformed Nonconformist”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec2-54",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“Shattered Dreams”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pauline Hermeneutics in Twentieth-Century Black Discourse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4. Pauline Language in Enslaved Conversion Experiences and Call Narratives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conversion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Story of Morte")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Story of Charlie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Saw Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traveling to the Third Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meeting God in the Blackberry Patch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pauline Language Permeates the Conversion Narratives of the Enslaved")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/013_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5. African American Pauline Hermeneutics and the Art of Biblical Interpretation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul as a Figure of Liberation and Equality, and of Shared Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul and the Hermeneutic of Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cosmological Paul and “Canonical” Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul and the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Body Language: A Pauline Body Hermeneutic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(The) Text Matters: “Findin’ Out Different”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Do We Go from Here?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Afterword#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Afterword")]), _vm._v(" by Beverly Roberts Gaventa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Bibliography#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb0fd014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0